<script setup>
import { onClickOutside } from '@vueuse/core';
import { ref, computed, watch } from 'vue';
import { Arrow, Cross }   from '../../Icons';
import DropdownContent    from './DropdownContent.vue'
import { DataPicker }     from '../Index';
import Input              from '../Input.vue';

const props = defineProps({
	dropdowns : Object,
	cardId    : Number,
})

const draft = defineModel();

const emit = defineEmits(['update:service', 'setComplete', 'setTime']);

const selectedService = ref(null); 
const selectedMaster  = ref(null);
const targetElement   = ref(null);
const selectedItem    = ref('');
const currentStep     = ref(1);
const dropInput       = ref(null);
const isOpen          = ref(false);

const currentDropdown = computed(() => {
	if (Array.isArray(props.dropdowns))
		return props.dropdowns.find((_, i) => ++i == currentStep.value) || {};
	else
		return props.dropdowns;
});

const filterValue = computed(() => {
	return selectedItem.value ?
		currentDropdown.value.values.filter(el => (el.title || el.fullname || '').toLowerCase().includes(selectedItem.value.toLowerCase())) :
		currentDropdown.value.values;
})

const placeholder = computed(() =>
	Array.isArray(props.dropdowns) ? 'Поиск' : props.dropdowns.placeholder
)

const updateItem = ({ id, value }) => {
	selectedItem.value = currentDropdown.value?.values.find(el => el.id == value).title;

	if (currentStep.value == props.dropdowns.length) {
		isOpen.value = !isOpen.value;
		
		emit('setComplete', {
			service: selectedService.value,
			master: selectedMaster.value,
		})
	}

	currentStep.value++;
	selectedItem.value = null;

	if (currentStep.value == 2)
		emit('update:service', { value })
}

const setTime = ({ date, time }) => {
	selectedItem.value = date;
	isOpen.value = false;

	draft.value.date = date;
	draft.value.time = time;

	emit('setTime')
}

const switchService = () => currentStep.value--;

// время сбросили снаружи (услуги не влезли) — убираем показанную дату
watch(() => draft.value?.time, time => {
	if (!time && !Array.isArray(props.dropdowns))
		selectedItem.value = '';
});

onClickOutside(targetElement, () => isOpen.value = false, { ignore: [ dropInput ] })
</script>

<template>
	<div
		class="dropdown-wr"
		:class="{'active': isOpen}"
	>
		<button
			class="dropdown__head"
			v-if="!isOpen"
			:class="{'active': selectedItem}"
			@click="isOpen = !isOpen"
		>
			<span>{{ selectedItem || currentDropdown.title }}</span>
			<Arrow v-if="!selectedItem"/>
			<Cross v-else />
		</button>
		<Input
			class="dropdown__input"
			ref="dropInput"
			v-else
			v-model:value="selectedItem"
			:placeholder
		/>
		<div ref="targetElement">
			<DropdownContent
				v-if="Array.isArray(props.dropdowns) && currentDropdown && isOpen"
				v-model:master="selectedMaster"
				v-model:service="selectedService"
				:filterValue
				:id="currentDropdown.id"
				:type="currentDropdown.type"
				:title="currentDropdown.title"
				:cardId
				@update:item="updateItem"
				@switchService="switchService"
			/>
			<DataPicker
				v-else-if="currentDropdown && isOpen"
				v-model="draft"
				@setTime="setTime"
			/>
		</div>
	</div>
</template>

<style lang="scss">
.dropdown-wr {
	position: relative;	
}

.dropdown__head {
	width: 100%;
	height: 60px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	text-align: left;
	position: relative;
	background-color: #ffffff;
	border-radius: 12px;
	padding-inline: 16px;
	font-size: 16px;
	font-family: 'Raleway';
	font-weight: 500;
	color: #D9D9D9;

	&.active { color: #000 }
}

.clear-input {
	width: 20px;
	height: 20px;
	position: absolute;
	top: 20px;
	right: 16px;
}
</style>
